export default __webpack_public_path__ + "static/media/cadd-centre.a896cae0.webp";